class SizeHelper {

  private sizeMap = new Map([
    ['x-small', 'xs'],
    ['small', 'xm'],
    ['medium', 'md'],
    ['large', 'lg'],
  ]);

  public getCorrectSize(size: string): string {
    const candidate = this.sizeMap.has(size);
    return candidate ? this.sizeMap.get(size) : size;
  }
}

export const sizeMapHelper = new SizeHelper();
